import useMediaQuery from "./useMediaQuery";

function useMediaQueries() {
  const isAbove576 = useMediaQuery("screen and (min-width: 576px)");
  const isAbove768 = useMediaQuery("screen and (min-width: 768px)");
  const isAbove922 = useMediaQuery("screen and (min-width: 992px)");
  const isAbove1200 = useMediaQuery("screen and (min-width: 1200px)");

  return { isAbove576, isAbove768, isAbove922, isAbove1200 };
}

export default useMediaQueries;
